import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { getCatalog, getTagFilters } from "@/services/catalog";
import type { CatalogQueryParams, CatalogResponse, TagFilterResponse } from "@/types/catalog";
export function useCatalog(params) {
  const $ = _c(2);
  let t0;
  if ($[0] !== params) {
    t0 = {
      queryKey: ["catalog", params],
      queryFn: () => getCatalog(params),
      placeholderData: _temp
    };
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}
function _temp(prev) {
  return prev;
}
export function useCatalogInfinite(baseParams, t0, t1) {
  const $ = _c(10);
  const initialPage = t0 === undefined ? 1 : t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== baseParams) {
    t2 = ["catalog", "infinite", baseParams];
    $[0] = baseParams;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const queryKey = t2 as const;
  let t3;
  if ($[2] !== baseParams || $[3] !== initialPage) {
    t3 = t4 => {
      const {
        pageParam: t5
      } = t4;
      const pageParam = t5 === undefined ? initialPage : t5;
      const pageNumber = typeof pageParam === "number" ? pageParam : initialPage;
      const params = {
        ...(baseParams ?? {}),
        page: pageNumber
      };
      if (!params.limit) {
        params.limit = 20;
      }
      return getCatalog(params);
    };
    $[2] = baseParams;
    $[3] = initialPage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== enabled || $[6] !== initialPage || $[7] !== queryKey || $[8] !== t3) {
    t4 = {
      queryKey,
      queryFn: t3,
      initialPageParam: initialPage,
      getNextPageParam: _temp2,
      enabled
    };
    $[5] = enabled;
    $[6] = initialPage;
    $[7] = queryKey;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return useInfiniteQuery(t4);
}
function _temp2(lastPage) {
  const meta = lastPage.data.meta;
  if (meta.current_page < meta.total_pages) {
    return meta.current_page + 1;
  }
}
export function useTagFilters() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["catalog-tags"],
      queryFn: _temp3,
      staleTime: 300000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}
function _temp3() {
  return getTagFilters();
}